// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "48f1da3-dirty",
    "hash": "48f1da3",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "48f1da3-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
